import { makeStyles, Theme } from "@material-ui/core";

const useRowStyles = makeStyles((theme: Theme) => ({
    overdue: {
        background: "#dc5950",
        cursor: "pointer",
        "&:hover": {
            background: `${theme.palette.error.light} !important`
        },
        "& td": {
            color: theme.palette.error.contrastText
        }
    },
    close: {
        background: "#f79447",
        cursor: "pointer",
        "&:hover": {
            background: `${theme.palette.secondary.light} !important`
        },
        "& td": {
            color: theme.palette.secondary.contrastText
        }
    },
    standard: {
        cursor: "pointer"
    }
}));

export default useRowStyles;
